import { User } from "@supabase/supabase-js";

export function getUserConfirmedAt(
  user: User | null | undefined,
): string | null {
  return user?.email_confirmed_at ?? user?.confirmed_at ?? null;
}
